module.exports = __webpack_public_path__ + "img/ep6-8.391acb95.png";